export default function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}